module.exports = __webpack_public_path__ + "img/cp_photo2.b8500805.png";